import CircularProgress from "@mui/material/CircularProgress";
import { CSSProperties } from "@mui/styles";

export function CenteredProgess({ style, color }: { style?: CSSProperties; color?: "secondary" | "primary" }) {
    return <CircularProgress sx={{ margin: "5vh auto", display: "block", ...style }} color={color || "secondary"} />;
}
